module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/1fa6345d57ffc67eccd9f44cf6a383dd.svg";